import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { RegistrationMode } from '~/engine/tool/tools/RegistrationTool';
import {
    registrationModeState,
    selectedToolState,
} from '~/state/atoms/toolsAtoms';
import { OverlayLabel, OverlayRow } from './OverlayLabel';

const isMac = navigator.platform.toUpperCase().includes('MAC');
const modifierKey = isMac ? 'Cmd' : 'Ctrl';

const RegistrationShortcutHints = () => {
    const location = useLocation();
    const tool = useRecoilValue(selectedToolState);
    const registrationMode = useRecoilValue(registrationModeState);

    const isRegistrationPage = location.pathname.startsWith(
        '/image-registration'
    );

    if (
        !isRegistrationPage ||
        tool !== 'registration' ||
        !registrationMode.mode
    ) {
        return null;
    }

    const isTranslation =
        registrationMode.mode === RegistrationMode.TRANSLATION;
    const modeLabel = isTranslation ? 'Translate' : 'Rotate';
    const hint = `${modifierKey}+Arrows: ${modeLabel}`;

    return (
        <OverlayRow sx={{ alignItems: 'center', px: 0.25, ml: -0.25 }}>
            <OverlayLabel>{hint}</OverlayLabel>
        </OverlayRow>
    );
};

export default RegistrationShortcutHints;
